import puzzleOn from '@/assets/tab-icons/puzzle.svg';
import puzzleOff from '@/assets/tab-icons/puzzle_unselected.svg';
import abcOn from '@/assets/tab-icons/abc.svg';
import abcOff from '@/assets/tab-icons/abc_unselected.svg';
import searchOn from '@/assets/tab-icons/search.svg';
import searchOff from '@/assets/tab-icons/search_unselected.svg';
import moreOn from '@/assets/tab-icons/more.svg';
import moreOff from '@/assets/tab-icons/more_unselected.svg';

/** Same selected / unselected drawings and sizes as the native tab bar. */
const TAB_ICONS = {
  learn: {
    on: puzzleOn,
    off: puzzleOff,
    onSize: { width: 36, height: 36 },
    offSize: { width: 24, height: 24 },
  },
  alphabet: {
    on: abcOn,
    off: abcOff,
    onSize: { width: 36, height: 36 },
    offSize: { width: 32, height: 28 },
  },
  search: {
    on: searchOn,
    off: searchOff,
    onSize: { width: 32, height: 32 },
    offSize: { width: 24, height: 24 },
  },
  settings: {
    on: moreOn,
    off: moreOff,
    onSize: { width: 36, height: 36 },
    offSize: { width: 28, height: 28 },
  },
} as const;

export type LearnerTabIconName = keyof typeof TAB_ICONS;

export function LearnerTabIcon({ name, active }: { name: LearnerTabIconName; active: boolean }) {
  const spec = TAB_ICONS[name];
  const size = active ? spec.onSize : spec.offSize;
  return (
    <span className="grid h-11 w-11 place-items-center">
      <img
        src={active ? spec.on : spec.off}
        alt=""
        width={size.width}
        height={size.height}
        className="object-contain"
        draggable={false}
        data-tab-icon={name}
        data-tab-icon-state={active ? 'selected' : 'unselected'}
      />
    </span>
  );
}
